// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/overlay/index.css
// module id = 870
// module chunks = 153